export default __webpack_public_path__ + "static/media/interface-5.b4a0b2af.png";